import React, { useState, useEffect, lazy } from "react";
import "../style.scss";
import Fade from "react-reveal/Fade";
import { useLocation } from "react-router-dom";
import LazyRender from "../Components/LazyRender";
// import Introduction from '../Components/index/Introduction'

const Counter = lazy(() => import("../Components/index/counter"));
// const ServicesV2Db = lazy(
//   () => import("../Components/index/Services/Services"),
// );
const NewServices = lazy(
  () => import("../Components/index/Services/NewServices"),
);
const NewBusiness = lazy(() => import("../Components/index/NewBusiness"));
const Introduction = lazy(() => import("../Components/index/Introduction"));
const Compliance = lazy(() => import("../Components/index/Compliance"));
const ClientsDb = lazy(() => import("../Components/index/ClientsDb"));
const MediaDb = lazy(() => import("../Components/index/DbMedia"));
// const SystemsAnimation = lazy(() => import('../Components/index/SystemsAnimation'));
const CanvaSystems = lazy(() => import("../Components/index/CanvaSystems"));
const MenuCarousel = lazy(() => import("../Components/index/Menu_Carousel"));
const ValooresBuilding = lazy(
  () => import("../Pages/ValooresBuilding/ValooresBuilding"),
);
// const Search = lazy(() => import('../Search/Search'));

const Home = ({ Ip }) => {
  const [isMobile, setIsMobile] = useState(false);

  const location = useLocation();
  useEffect(() => {
    const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
    setIsMobile(isMobileDevice);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      {isMobile ? (
        <div>
          <MenuCarousel Ip={Ip} />
          <LazyRender>
            <Introduction />
          </LazyRender>
          <LazyRender>
            <Compliance />
          </LazyRender>
          <LazyRender>
            <CanvaSystems Ip={Ip} />
          </LazyRender>
          {/* <LazyRender><SystemsAnimation Ip={Ip} /></LazyRender> */}
          {/* <LazyRender><Business Ip={Ip} /></LazyRender> */}
          <LazyRender id="business_scroll">
            <NewBusiness Ip={Ip} />
          </LazyRender>
          {/* <LazyRender id="services_scroll">
            <ServicesV2Db Ip={Ip} />
          </LazyRender> */}
          <LazyRender id="services_scroll">
            <NewServices Ip={Ip} />
          </LazyRender>
          <LazyRender id="partners_scroll">
            <ClientsDb Ip={Ip} />
          </LazyRender>
          <LazyRender>
            <Counter />
          </LazyRender>
          {/* <LazyRender><Search Ip={Ip}/></LazyRender> */}
          <LazyRender id="media">
            <MediaDb Ip={Ip} />
          </LazyRender>
          <LazyRender id="media">
            <ValooresBuilding Ip={Ip} />
          </LazyRender>
        </div>
      ) : (
        <>
          <MenuCarousel Ip={Ip} />
          <Fade>
            <LazyRender>
              <Introduction />
            </LazyRender>
            <LazyRender>
              <Compliance />
            </LazyRender>
            <LazyRender>
              <CanvaSystems Ip={Ip} />
            </LazyRender>
            {/* <LazyRender><SystemsAnimation Ip={Ip} /></LazyRender> */}
            {/* <LazyRender><Business Ip={Ip} /></LazyRender> */}
            <LazyRender id="business_scroll">
              <NewBusiness Ip={Ip} />
            </LazyRender>
            {/* <LazyRender id="services_scroll">
              <ServicesV2Db Ip={Ip} />
            </LazyRender> */}
            <LazyRender id="services_scroll">
              <NewServices Ip={Ip} />
            </LazyRender>
            <LazyRender id="partners_scroll">
              <ClientsDb Ip={Ip} />
            </LazyRender>
            <LazyRender>
              <Counter />
            </LazyRender>
            {/* <LazyRender><Search Ip={Ip}/></LazyRender> */}
            <LazyRender id="media">
              <MediaDb Ip={Ip} />
            </LazyRender>
            <LazyRender id="media">
              <ValooresBuilding Ip={Ip} />
            </LazyRender>
          </Fade>
        </>
      )}
    </>
  );
};

export default Home;
